export default __webpack_public_path__ + "static/media/logo.094595b3.png";